import { mix as _mix } from "@thi.ng/math";
import { mixN4, setC4 } from "@thi.ng/vectors";
export const mix = mixN4;
export const mixAlpha = (out, a, b) => setC4(out || a, _mix(a[0], b[0], a[3]), _mix(a[0], b[0], a[3]), _mix(a[0], b[0], a[3]), a[3]);
